import {assocPath, pipe, map, omit, isEmpty} from 'ramda'

import {BookingRequestType} from 'types/bookingRequest'

export const setSessionStorageItem = (
  key: string,
  obj: Record<string, unknown>
) => {
  window.sessionStorage.setItem(key, JSON.stringify(obj))
}

export const getSessionStorageItem = (key: string) => {
  return JSON.parse(window.sessionStorage.getItem(key))
}

const SESSION_STORAGE_FORM_DATA_KEY = 'formData'
const SESSION_STORAGE_REFRESHED_BROWSER_ONCE = 'refreshedOnce'

const emptyCreditCardData = () => ({
  expirationMonth: '',
  expirationYear: '',
  number: '',
  rawExpirationDate: '',
  securityCode: '',
  cardholdersName: '',
  type: ''
})

const omitRoomsOptions = formData => {
  if (isEmpty(formData)) return

  return map(omit(['bedType', 'smoking']), formData.rooms)
}

export const setFormData = (formData: Record<string, unknown>) => {
  const sanitizedFormData = pipe(
    assocPath(['payment', 'creditCard'], emptyCreditCardData()),
    assocPath(['rooms'], omitRoomsOptions(formData)),
    assocPath(['payment', 'billing', 'address', 'fullAddress'], '')
  )(formData)

  return setSessionStorageItem(SESSION_STORAGE_FORM_DATA_KEY, sanitizedFormData)
}

export const setPageAsRefreshedStatus = (status = true) => {
  return setSessionStorageItem(SESSION_STORAGE_REFRESHED_BROWSER_ONCE, status)
}

export const getPageAsRefreshedStatus = () => {
  return getSessionStorageItem(SESSION_STORAGE_REFRESHED_BROWSER_ONCE) || false
}

export const getFormData = (): BookingRequestType => {
  return getSessionStorageItem(SESSION_STORAGE_FORM_DATA_KEY) || {}
}
